module.exports = __webpack_public_path__ + "static/media/faccia_02.e184b515.png";